import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Avatar, AvatarGroup, Button, Checkbox, Chip, CircularProgress, Dialog, IconButton, Modal, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Menu, MenuItem, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, useParams } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import moment from 'moment';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSnackbar } from 'notistack';
import TuneIcon from '@mui/icons-material/Tune';
import Filters2 from 'elements/Filters/Filters2';
import FiltersApplied2 from 'elements/Filters/FiltersApplied2';
import { TbFileExport } from "react-icons/tb";
import ExportClientsDialog from './Components/ExportClientsDialog';
import { RiDeleteBin6Line } from "react-icons/ri";
import { PiDotsThreeOutlineFill, PiPencilLight, PiXCircleLight } from "react-icons/pi";
import OrdersEditor from './OrdersEditor';
import { ApiRequest } from 'GlobalFunctions';

export default function OrdersList(props: any) {

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const {setLoading} = props;

  useEffect(() => {
    setLoading(false);
  }, [])
  
  const [list, setList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  // Multi-select state
  const [selectedOrderIds, setSelectedOrderIds] = useState<Set<number>>(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [deselectedWhenAll, setDeselectedWhenAll] = useState<Set<number>>(new Set());
  const [totalItems, setTotalItems] = useState(0);
  const selectedCount = selectAll ? totalItems - deselectedWhenAll.size : selectedOrderIds.size;
  const isHeaderChecked = selectAll && deselectedWhenAll.size === 0;
  const isHeaderIndeterminate = (selectAll && deselectedWhenAll.size > 0) || (!selectAll && selectedOrderIds.size > 0);
  const isRowSelected = (orderId: number) => selectAll ? !deselectedWhenAll.has(orderId) : selectedOrderIds.has(orderId);

  const handleSelectAll = () => {
    if (selectAll && deselectedWhenAll.size === 0) {
      setSelectAll(false);
      setSelectedOrderIds(new Set());
      setDeselectedWhenAll(new Set());
    } else {
      setSelectAll(true);
      setSelectedOrderIds(new Set());
      setDeselectedWhenAll(new Set());
    }
  };

  const handleRowSelect = (orderId: number) => {
    if (selectAll) {
      const newDeselected = new Set(deselectedWhenAll);
      if (newDeselected.has(orderId)) {
        newDeselected.delete(orderId);
      } else {
        newDeselected.add(orderId);
      }
      setDeselectedWhenAll(newDeselected);
    } else {
      const newSelected = new Set(selectedOrderIds);
      if (newSelected.has(orderId)) {
        newSelected.delete(orderId);
      } else {
        newSelected.add(orderId);
      }
      setSelectedOrderIds(newSelected);
    }
  };

  const queryParams = new URLSearchParams(window.location.search);

  const [page, setPage] = useState(1);
  const [filtersValues, setFiltersValues] = useState<any>([]);
  const [open, setOpen] = useState(false);

  const [openEditor, setOpenEditor] = useState(false);
  const [restrictions, setRestrictions] = useState<any>(null);
  const [advancedOrderEditor, setAdvancedOrderEditor] = useState(false);
  const [undeliveredView, setUndeliveredView] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOrderId, setSelectedOrderId] = useState<number | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const openMenu = Boolean(anchorEl);



  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, orderId: number, item: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedOrderId(orderId);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedOrderId(null);
    setSelectedItem(null);
  };

  const handleOrderSummary = () => {
    console.log("Resumen de pedido");
  };

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page, filtersValues])

  // Reset selection when filters change
  useEffect(() => {
    setSelectAll(false);
    setSelectedOrderIds(new Set());
    setDeselectedWhenAll(new Set());
  }, [filtersValues]);

  // Add auto-refresh interval
  useEffect(() => {
    const interval = setInterval(() => {
      loadList();
    }, 10000); // 10 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [page, filtersValues]);

  /*=========================================================
  LOAD LIST
  =========================================================*/
  const loadList = async () => {

    await ApiRequest({
      url: "/purchases/orders/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        page: page,
        filters: filtersValues,
      },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setTotalItems(response.total_items || 0);
        setLoading(false);
      },
    });
    
    // localStorage.setItem('page', page.toString())
}


  const gerRestrictions = async () => {
    await ApiRequest({
      url: "/companies/restrictions",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      setResponse: (response: any) => {
        setRestrictions(response);
        setAdvancedOrderEditor(response.advancedOrderEditor);
      },
    });
  }

  useEffect(() => {
    gerRestrictions();
  }, [])


  /*=========================================================*/



  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (order_id:number) => {
    setPendingDeleteOrderId(order_id);
    setOpenDeletePasswordDialog(true);
  }



  const deleteItem = () => {
    if (!deleteMasterPassword) {
      enqueueSnackbar('Por favor ingrese la contraseña maestra', { variant: 'error' });
      return;
    }

    setLoading(true);

    const body = {
      order_id: pendingDeleteOrderId,
      master_password: deleteMasterPassword
    }

    ApiRequest({
      url: "/purchases/orders/deleteItem",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body,
      setResponse: (response: any) => {
        if(response.status === "success"){
          enqueueSnackbar('Pedido eliminado con éxito', { variant: 'success' });
          loadList();
          setOpenDeletePasswordDialog(false);
          setDeleteMasterPassword("");
          setShowDeletePassword(false);
          setPendingDeleteOrderId(null);
        } else {
          enqueueSnackbar(response.message || 'Error al eliminar el pedido', { variant: 'error' });
        }
        setLoading(false);
      },
      error: (err: any) => {
        console.log(err);
        enqueueSnackbar('Error al eliminar el pedido', { variant: 'error' });
        setLoading(false);
      }
    });
  }
  

  /*=========================================================
  VOID PAYMENT
  =========================================================*/
  const handleVoidOrder = (order_id: number) => {
    setActiveVoidItem(order_id);
    setOpenVoidAlert(true);
  };

  const voidOrder = () => {
    const body = {
      order_id: activeVoidItem,
    };

    ApiRequest({
      url: '/purchases/orders/voidOrder',
      method: 'post',
      headers: {
        ltkn: localStorage.getItem('ltkn'),
      },
      body,
      setResponse: (response: any) => {
        enqueueSnackbar('Recaudo anulado correctamente', { variant: 'success' });
        //reload list
        loadList();
      },
    });
  };

  /*=========================================================
  EXPORT ORDER
  =========================================================*/
  const handleExportOrder = (order_id: number) => {
    setLoading(true);
    ApiRequest({
      url: "/purchases/orders/exportOrder",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        order_id: order_id,
      },
      setResponse: (response: any) => {
        console.log(response)
        if (response) {
            downloadFile(response);
          }
        setLoading(false);
      },
    });
  };

// call global snackbar
  
const [openAlert, setOpenAlert] = useState(false);
const [activeItem, setActiveItem] = useState<any>(null);

const [openVoidAlert, setOpenVoidAlert] = useState(false);
const [activeVoidItem, setActiveVoidItem] = useState<any>(null);

const filters = [
  { type: "date_range", label: "Fecha", name: "date", value: "January 13, 2025 - January 13, 2025", mandatory: true },
  { type: "select", label: "Estado", name: "processed", value: "", options: [{label: "Todos", value: "all"}, {label: "Procesado", value: "1"}, {label: "No procesado", value: "0", default: true} ] },
  { type: "autocomplete", label: "Vendedor", name: "u.user_id", value: "", endpoint: "/users/listByRole", endpoint_params: { role_ids: [4,6,7] } },
  { type: "text", label: "Zona", name: "zone", value: "" },
  
  { type: "text", label: "Nombre cliente", name: "client_name", value: "" },
  { type: "text", label: "Nombre negocio", name: "business_name", value: "" },
  { type: "text", label: "NIT", name: "document", value: "" },
  
];

const setFilters = (tempFilters: any) => {
  setFiltersValues(tempFilters);
  localStorage.setItem('filters', JSON.stringify(tempFilters));
};

const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
const [downloadFiles, setDownloadFiles] = useState<{ordersFile: string, productsFile: string} | null>(null);
const [openDownloadPRNDialog, setOpenDownloadPRNDialog] = useState(false);
const [downloadPRNFiles, setDownloadPRNFiles] = useState<{pedidosFile: string, cerosFile: string} | null>(null);

const exportCSV = () => {
  if (selectedCount === 0 && (!filtersValues?.date?.value?.startDate || !filtersValues?.date?.value?.endDate)) {
    enqueueSnackbar('Debe seleccionar un rango de fechas', { variant: 'error' });
    return;
  }
  setLoading(true);

  let body: any = {};
  if (!selectAll && selectedOrderIds.size > 0) {
    body.order_ids = Array.from(selectedOrderIds).join(',');
  } else {
    body.filters = filtersValues;
    if (selectAll && deselectedWhenAll.size > 0) {
      body.deselected_order_ids = Array.from(deselectedWhenAll).join(',');
    }
  }

  ApiRequest({
    url: "/purchases/orders/exportCSV",
    method: "post",
    headers: {
      ltkn: localStorage.getItem("ltkn"),
    },
    body,
    setResponse: (response: any) => {
      if (response.status === "success") {
        setDownloadFiles({
          ordersFile: response.ordersFile,
          productsFile: response.productsFile
        });
        setOpenDownloadDialog(true);
        loadList();
      }
      setLoading(false);
    }
  });
}

const exportPRN = () => {
  if (selectedCount === 0 && (!filtersValues?.date?.value?.startDate || !filtersValues?.date?.value?.endDate)) {
    enqueueSnackbar('Debe seleccionar un rango de fechas', { variant: 'error' });
    return;
  }
  setLoading(true);

  let body: any = {};
  if (!selectAll && selectedOrderIds.size > 0) {
    body.order_ids = Array.from(selectedOrderIds).join(',');
  } else {
    body.filters = filtersValues;
    if (selectAll && deselectedWhenAll.size > 0) {
      body.deselected_order_ids = Array.from(deselectedWhenAll).join(',');
    }
  }

  ApiRequest({
    url: "/purchases/orders/exportPRN",
    method: "post",
    headers: {
      ltkn: localStorage.getItem("ltkn"),
    },
    body,
    setResponse: (response: any) => {
      if (response.status === "success") {
        setDownloadPRNFiles({
          pedidosFile: response.pedidosFile,
          cerosFile: response.cerosFile
        });
        setOpenDownloadPRNDialog(true);
        loadList();
      }
      setLoading(false);
    }
  });
}

const downloadFile = async (url: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const filename = url.split('/').pop() || 'download.txt';
    
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('Error downloading file:', error);
    enqueueSnackbar('Error al descargar el archivo', { variant: 'error' });
  }
};

const [openExportClients, setOpenExportClients] = useState(false);

  // Master password for delete
  const [openDeletePasswordDialog, setOpenDeletePasswordDialog] = useState(false);
  const [deleteMasterPassword, setDeleteMasterPassword] = useState("");
  const [showDeletePassword, setShowDeletePassword] = useState(false);
  const [pendingDeleteOrderId, setPendingDeleteOrderId] = useState<number | null>(null);
  
  return (
      <div id='UsersList' className='ModuleContainer'>
        <div className="ModuleWrapper"> 
          <div className="boxContainerHeader">
            
            <div className="boxContainerTitle">
              <h2 className="h2_title">Pedidos - Compra</h2>
              <span className="h2_subtitle">Lista de pedidos creados</span>
            </div>
            
            <div className='module_tools'>
            
          </div>
          
            <div className="boxContainerActions">
              <Button
              variant="outlined"
              color="primary"
              startIcon={<TuneIcon />}
              onClick={() => setOpen(true)}
            >
              Filtrar
            </Button>

            <Button
              variant="contained"
              color="secondary"
              startIcon={<TbFileExport />}
              onClick={() => setOpenExportClients(true)}
            >
              Exportar Clientes
            </Button>




            </div>
            
          </div>


          

          <Filters2 open={open} setOpen={setOpen} filters={filters} setFilters={setFilters} />
          <FiltersApplied2 filtersValues={filtersValues} setFiltersValues={setFiltersValues} filters={filters} />

          <div id='UsersListIn'>


            
              <Box id='WarehouseList' className='box100'>
              <TableContainer>
              <Table aria-label="sticky table"> 
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox" sx={{borderBottom:"none"}}>
                      <Checkbox
                        checked={isHeaderChecked}
                        indeterminate={isHeaderIndeterminate}
                        onChange={handleSelectAll}
                        size="small"
                      />
                    </TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>ID</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Cliente</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Zona</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Vendedor</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Tipo</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Fecha / HORA</TableCell>
                    <TableCell sx={{color:'#a8a8a8', borderBottom:"none"}}>Procesado</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((item,i) => {

                      const date = moment(item.date).format('DD/MM/YYYY');
                      const time = moment(item.date).format('HH:mm');

                      return(
                      <TableRow 
                        
                        key={i}
                        hover
                        role="checkbox"
                        selected={isRowSelected(item.order_id)}
                      >        

                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isRowSelected(item.order_id)}
                          onChange={() => handleRowSelect(item.order_id)}
                          size="small"
                        />
                      </TableCell>

                      <TableCell>
                        {item.company_order_id}
                      </TableCell>              

                        <TableCell>
                        <span className='flex_title'>{item.client_name + " " + item.client_last_name}</span>
                        <span className='flex_subtitle'>{item.business_name}</span>
                        </TableCell>

                        <TableCell>
                          <span className='flex_title'>{item.zone_name}</span>
                          <span className='flex_subtitle'>{item.zone_code}</span>
                        </TableCell>

                        <TableCell>
                          {item.user_name}
                        </TableCell>  

                        <TableCell>
                          <Chip
                            label={item.order_type_label}
                            size='small'
                            sx={{
                              backgroundColor:
                                item.order_type === 'order'
                                  ? '#1976d2' // primary blue
                                  : item.order_type === 'quote'
                                    ? '#e7a42a' // orange
                                    : item.order_type === 'undelivered'
                                      ? '#cd3131' // red
                                      : undefined,
                              color: '#fff',
                            }}
                          />
                        </TableCell>

                        <TableCell>
                          <span className='flex_title'>{date}</span>
                          <span className='flex_subtitle'>{time}</span>
                        </TableCell>

                        <TableCell>
                          {item.order_type === 'order' && (
                            <Chip
                              label={item.processed}
                              size='small'
                              sx={{
                                backgroundColor: item.processed === 'Procesado' ? 'success.main' : 'grey.500',
                                color: '#fff',
                              }}
                            />
                          )}
                        </TableCell>

                        <TableCell align="right">
                          {item.is_voided === 1 && (
                            <Chip
                              label="Anulado"
                              color="error"
                              variant="outlined"
                              size="small"
                            />
                          )}

                          <IconButton onClick={(e) => handleMenuClick(e, item.order_id, item)} size="small">
                            <PiDotsThreeOutlineFill />
                          </IconButton>
                          
                        </TableCell>
                      </TableRow>
                    )})}
                </TableBody>
              </Table>
            </TableContainer>
            
            <Pagination count={total_pages} page={page}  onChange={(event, value) => {
              setPage(value);
              document.getElementById('main-content')?.scrollTo({ top: 0, behavior: 'smooth' });
            }
            } 
            color="primary"
            style={{"marginTop": "20px","alignSelf": "center"}}
            />
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {selectedItem && (
                <>
                  <MenuItem onClick={() => { handleOrderSummary(); setUndeliveredView(selectedItem.order_type === 'undelivered'); setActiveItem(selectedOrderId); setOpenEditor(true); handleMenuClose(); }}>
                    <PiPencilLight style={{ marginRight: 8 }} />
                    Detalle
                  </MenuItem>
                  {selectedItem.order_type !== 'undelivered' && (
                    <MenuItem onClick={() => { handleExportOrder(selectedOrderId!); handleMenuClose(); }}>
                      <TbFileExport style={{ marginRight: 8 }} />
                      Exportar
                    </MenuItem>
                  )}
                  {selectedItem.order_type !== 'undelivered' && (
                    <MenuItem onClick={() => { handleDelete(selectedOrderId!); handleMenuClose(); }} sx={{ color: 'error.main' }}>
                      <PiXCircleLight style={{ marginRight: 8 }} />
                      Borrar
                    </MenuItem>
                  )}
                  {selectedItem.order_type !== 'undelivered' && selectedItem.is_voided !== 1 && (
                    <MenuItem onClick={() => { handleVoidOrder(selectedOrderId!); handleMenuClose(); }}>
                      <RiDeleteBin6Line style={{ marginRight: 8 }} />
                      Anular
                    </MenuItem>
                  )}
                </>
              )}
            </Menu>
  
          </div>
        </div>

        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar este pedido? Esta acción no se puede deshacer."
            send={deleteItem}
        />

        <AlertDialog
          open={openVoidAlert}
          setOpen={setOpenVoidAlert}
          subtitle="¿Está seguro que desea anular este recaudo?"
          send={voidOrder}
        />



        <OrdersEditor
          setLoading={setLoading}
          openEditor={openEditor} 
          setOpenEditor={setOpenEditor}
          order_id={activeItem} 
          loadList={loadList}
          handleClose={() => setOpenEditor(false)}
          advancedOrderEditor={advancedOrderEditor}
          undeliveredView={undeliveredView}
        />

        {/* Master Password Dialog for Delete */}
        <Dialog
          open={openDeletePasswordDialog}
          onClose={() => {
            setOpenDeletePasswordDialog(false);
            setDeleteMasterPassword("");
            setShowDeletePassword(false);
            setPendingDeleteOrderId(null);
          }}
        >
          <div className="DialogContainer" style={{maxWidth:'450px'}}>
            <div className="ModuleWrapper">
              <div className="boxContainerHeader">
                <div className="boxContainerTitle">
                  <h2 className="h2_title">Confirmar eliminación</h2>
                  <span className="h2_subtitle">Para eliminar este pedido, ingrese la contraseña maestra</span>
                </div>
              </div>

              <TextField
                label="Contraseña maestra"
                type={showDeletePassword ? "text" : "password"}
                fullWidth
                value={deleteMasterPassword}
                onChange={(e) => setDeleteMasterPassword(e.target.value)}
                margin="normal"
                autoFocus
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={() => setShowDeletePassword(!showDeletePassword)}
                      edge="end"
                    >
                      {showDeletePassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                }}
              />
            </div>
          </div>

          <div className="dialogButtons">
            <Button
              onClick={() => {
                setOpenDeletePasswordDialog(false);
                setDeleteMasterPassword("");
                setShowDeletePassword(false);
                setPendingDeleteOrderId(null);
              }}
              variant="outlined"
              className="button_2"
            >
              Cancelar
            </Button>

            <Button
              onClick={deleteItem}
              variant="contained"
              className="button_1"
              color="error"
            >
              Eliminar
            </Button>
          </div>
        </Dialog>

        <Dialog
          open={openDownloadDialog}
          onClose={() => setOpenDownloadDialog(false)}
          aria-labelledby="download-dialog-title"
        >
          <div style={{ padding: '20px' }}>
            <h2 id="download-dialog-title" style={{ marginBottom: '20px' }}>Descargar archivos exportados (CSV)</h2>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => downloadFiles?.ordersFile && downloadFile(downloadFiles.ordersFile)}
              >
                Descargar Pedidos
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => downloadFiles?.productsFile && downloadFile(downloadFiles.productsFile)}
              >
                Descargar Productos
              </Button>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={openDownloadPRNDialog}
          onClose={() => setOpenDownloadPRNDialog(false)}
          aria-labelledby="download-prn-dialog-title"
        >
          <div style={{ padding: '20px' }}>
            <h2 id="download-prn-dialog-title" style={{ marginBottom: '20px' }}>Descargar archivos exportados (PRN)</h2>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => downloadPRNFiles?.pedidosFile && downloadFile(downloadPRNFiles.pedidosFile)}
              >
                Descargar Pedidos (PRN)
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => downloadPRNFiles?.cerosFile && downloadFile(downloadPRNFiles.cerosFile)}
              >
                Descargar Ceros (PRN)
              </Button>
            </div>
          </div>
        </Dialog>

        <ExportClientsDialog 
          open={openExportClients}
          onClose={() => setOpenExportClients(false)}
        />

        {selectedCount > 0 && (
          <div className="selection_toolbar">
            <span className="selection_toolbar__count">
              <strong>{selectedCount}</strong> de {totalItems} pedidos seleccionados
            </span>
            <div className="selection_toolbar__actions">
              <Button
                variant="outlined"
                size="small"
                startIcon={<TbFileExport />}
                onClick={exportCSV}
              >
                Exportar Pedidos
              </Button>
              <Button
                variant="outlined"
                size="small"
                startIcon={<TbFileExport />}
                onClick={exportPRN}
              >
                Exportar Pedidos (PRN)
              </Button>
              <Button
                variant="text"
                size="small"
                onClick={() => {
                  setSelectAll(false);
                  setSelectedOrderIds(new Set());
                  setDeselectedWhenAll(new Set());
                }}
              >
                Cancelar
              </Button>
            </div>
          </div>
        )}

    </div>
  );
};